module.exports = __webpack_public_path__ + "static/img/home_banner2@2x.a2c1cf5f.png";